import { render, staticRenderFns } from "./AutomatedDeepLProject.vue?vue&type=template&id=48bb9972&"
import script from "./AutomatedDeepLProject.vue?vue&type=script&lang=js&"
export * from "./AutomatedDeepLProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports